import React, { useRef, useState, useEffect, useLayoutEffect } from "react";
import MiniSideBar from "../../components/mini-sidebar";
import {
  Box,
  Flex,
  Image,
  Menu,
  MenuButton,
  Text,
  MenuList,
  MenuItem,
  Td,
  Tr,
  Textarea,
  Card,
  CardBody,
  Divider,
  Input,
  SimpleGrid,
} from "@chakra-ui/react";
import SecondaryNav from "../../components/seconday-nav";
import PrimaryButton from "../../components/primary-button";
import DynamicModal from "../../components/dynamic-modal";
import ModalRight from "../../components/modal-right";
import useLoader from "../../components/loader/loaderstates";
import Loader from "../../components/loader/loader";
import SimpleTable from "../../components/simple-table";
import {
  DropdownInput,
  PrimaryInput,
  PrimaryInputDropdown,
  SearchBar,
  Toaster,
} from "../../components";

import { BrowserRouter as Router, useNavigate } from "react-router-dom";

import MobileNavbar from "../../components/mobile-navbar";
import MobileSecondaryNav from "../../components/mobile-secondary-navbar";
import { getCroppedImg, getLoginID, useScreenType } from "../../auth";
import {
  AddReferHospitals,
  DeleteReferHospitals,
  GetReferHospitals,
  UpdateReferHospitals,
} from "../../middleware/services/referhospitals";
import {
  FetchDoctorClinics,
  getProfile,
  saveClinicChanges,
  saveClinicDeletedChanges,
  saveClinicEditedChanges,
  updatePartnerLogoOnChange,
  uploadPartnerImageInProfile,
} from "../../middleware/services/profile";
import ImageCropper from "../profile/ImageCropper";

const PartnersIndex = () => {
  const { isLoading, showLoader, dismissLoader } = useLoader();
  const { showSuccessToast, showErrorToast } = Toaster();
  const [searchValue, setSearchValue] = useState([]);

  const [partnerName, setPartnerName] = useState(null);
  const [partnerLogo, setPartnerLogo] = useState(
    "/assets/imgs/no-image-icon.png"
  );
  const [clinics, setClinics] = useState("");
  const [clinicBranchList, setClinicBranchList] = useState([]);
  const [editedClinics, setEditedClinics] = useState(null);
  const [partnerBranchId, setPartnerBranchId] = useState("");
  const [partnerEditedBranchId, setPartnerEditedBranchId] = useState(null);
  const [resultPartner, setResultPartner] = useState([]);
  const [clinicList, setClinicList] = useState([]);
  const [editedPartnerName, setEditedPartnerName] = useState(null);
  const [uniqueId, setUniqueId] = useState(null);
  const [showPartnerLogoCropper, setShowPartnerLogoCropper] = useState(false);
  const [selectedPartnerLogo, setSelectedPartnerLogo] = useState("");
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [partnerLogoUrl, setPartnerLogoUrl] = useState(
    "/assets/imgs/no-image-icon.png"
  );
  const [resultBranch, setResultBranch] = useState([]);
  const [doctorid, setDoctorId] = useState("");
  const [editedPartnerLogo, setEditedPartnerLogo] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItemCount, setTotalItemCount] = useState(0);
  var itemPerPageCommonValue = 10;
  let [pagesize, setPagesize] = useState(itemPerPageCommonValue);
  let [pageno, setPageno] = useState(1);
  let [countTo, setCountTo] = useState(itemPerPageCommonValue);
  let [countFrom, setCountFrom] = useState(1);
  let [totalExceedsPageCount, setTotalExceedsPageCount] = useState(false);

  const addPartner = useRef();
  const editPartner = useRef();
  const deletePartner = useRef();
  const inputPartnerLogoRef = useRef();
  const editPartnerLogo = useRef();
  const screenType = useScreenType();
  const navigate = useNavigate();

  var inputForGet = {};

  const FetchClinicsList = async () => {
    showLoader();
    try {
      var result = await FetchDoctorClinics({
        type: "getbranchforpartner",
      });

      if (result && result.length > 0) {
        setClinicBranchList(result);
        const clinicsResult = result.map((item) => item.clinicname);
        setClinicList(clinicsResult);
      }
      dismissLoader();
    } catch (error) {
      console.log(error, "Something went wrong in doctor profile");
    }
  };

  const getDoctorProfile = async () => {
    showLoader();
    try {
      var result = await getProfile(inputForGet);

      if (result && result.resultbranch) {
        setResultBranch(result.resultbranch);
      }
      if (result && result.resultpartner) {
        setResultPartner(result.resultpartner);
      }
    } catch (error) {
      console.log(error, "Something went wrong in doctor profile");
    } finally {
      dismissLoader();
    }
  };

  function openPartnerModal(id, operation) {
    if (operation === "add") {
      setPartnerName("");
      setPartnerLogo("");
      setClinics("");
      FetchClinicsList();
      addPartner.current.openRight();
    } else {
      const editableData = resultPartner.find((item) => item.id === id);
      if (editableData) {
        setUniqueId(editableData.id);
        setEditedPartnerName(editableData.partnername);
        setEditedClinics(editableData.branchname);
        setEditedPartnerLogo(editableData.partnerlogo);
        setPartnerEditedBranchId(editableData.branchid);
        editPartner.current.openRight();
      }
    }
  }

  const openDeletePartnerModal = (step) => {
    setUniqueId(step.id);
    setPartnerName(step.partnername);
    deletePartner.current.openModal();
  };

  const deletePartnerInput = {
    doctorid: getLoginID(),
    id: uniqueId,
  };
  const deletePartnerFromList = async () => {
    try {
      const result = await saveClinicDeletedChanges(deletePartnerInput);

      if (result.output.message === "Successfully Deleted") {
        showSuccessToast("Partner Deleted Successfully");
        deletePartner.current.closeModal();
        getDoctorProfile();
      }
    } catch (error) {
      console.log(error, "Something went wrong in doctor profile");
    }
  };

  const handleClinicSelect = (selectedClinicName) => {
    setClinics(selectedClinicName);
    setEditedClinics(selectedClinicName);
    const selectedClinic = clinicBranchList.find(
      (clinic) => clinic.clinicname === selectedClinicName
    );
    if (selectedClinic) {
      // console.log('selectedClinciBranchId: ', selectedClinic.branchid)
      setPartnerBranchId(selectedClinic.branchid);
      setPartnerEditedBranchId(selectedClinic.branchid);
    }
  };

  const handleChangeName = (event) => {
    let inputValue = event.target.value;
    inputValue = inputValue.replace(/[^A-Za-z0-9\s@._-]/g, "").slice(0, 50);
    setSearchValue(inputValue);
  };

  async function handleFilter() {
    const trimmedName = searchValue?.trim();
    const inputToFetch = {
      input: {
        doctorid: getLoginID(),
        searchtext: trimmedName,
        // fromdate: "",
        // todate: "",
        // pageno: pageno,
        // pagesize: pagesize,
      },
    };
    showLoader();
    try {
      const result = await getProfile(inputToFetch.input);
      if (result && result.resultpartner) {
        setResultPartner(result.resultpartner);
      }
    } catch (error) {
      console.log("Error fetching parnter data", error);
    }
    dismissLoader();
  }

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleFilter();
    }
  };

  async function resetFeilds() {
    setSearchValue("");
    getDoctorProfile();
  }

  const handleNextClick = () => {
    let page = pageno + 1;

    setPageno(page);
    setCurrentPage(currentPage + 1);

    if (countTo + pagesize < totalItemCount) {
      setCountTo(countTo + pagesize);
    } else {
      setCountTo(totalItemCount);
    }

    setCountFrom(countFrom + pagesize);
  };
  const handlePrevClick = () => {
    let page = pageno - 1;

    setPageno(page);
    setCurrentPage(currentPage - 1);
    if (countTo == totalItemCount) {
      let updatedCountUnroundedValue = totalItemCount - pagesize;
      setCountTo(
        Math.ceil(updatedCountUnroundedValue / itemPerPageCommonValue) *
          itemPerPageCommonValue
      );
    } else {
      setCountTo(countTo - pagesize);
    }

    setCountFrom(countFrom - pagesize);
  };

  const handlePartnerLogoSelection = (e) => {
    e.preventDefault();
    const file = e.target.files[0];

    const allowedTypes = ["image/png", "image/jpeg", "image/jpg", "image/webp"];
    if (!allowedTypes.includes(file.type)) {
      showErrorToast(
        "Invalid file type. Please select a PNG, JPG or JPEG file."
      );
      return false;
    }

    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setSelectedPartnerLogo(reader.result);
        setShowPartnerLogoCropper(true);
        editPartnerLogo.current.openModal();
      };
      reader.readAsDataURL(file);
      e.target.value = "";
    }
  };

  let clinicInput = {
    // branchid: partnerBranchId,
    branchlinkid: partnerBranchId,
    loginid: getLoginID(),
    partnername: partnerName,
    partnerlogo: partnerLogo,
  };

  const saveClinicData = async () => {
    if (partnerBranchId == null) {
      showErrorToast("Please select Branch List!");
      return;
    }
    try {
      var result = await saveClinicChanges(clinicInput);

      if (result && result.output.result === "success") {
        showSuccessToast("Partner Details Added successfully");
        addPartner.current.closeRight();
        getDoctorProfile();
      }
    } catch (error) {
      console.log(error, "Something went wrong in doctor profile");
    }
  };

  const saveClinicEditedData = async () => {
    let clinicEditedInput = {
    branchlinkid: partnerEditedBranchId,
      loginid: getLoginID(),
      id: uniqueId,
      partnername: editedPartnerName,
      partnerlogo: editedPartnerLogo,
    };
    console.log(clinicEditedInput, "check edit input");
    if (!partnerEditedBranchId) {
      showErrorToast("Please select Branch List!");
      return;
    }
    try {
      var result = await saveClinicEditedChanges(clinicEditedInput);
      if (result && result.output.result === "success") {
        getDoctorProfile();
        showSuccessToast("Partner Details updated successfully");
        editPartner.current.closeRight();
      }
    } catch (error) {
      console.log(error, "Something went wrong in doctor profile");
    }
  };

  const changePartnerLogo = () => {
    if (inputPartnerLogoRef.current) {
      inputPartnerLogoRef.current.click();
    }
  };

  const handlePartnerLogoCropComplete = (croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  };

  const handlePartnerLogoCrop = async () => {
    showLoader();
    try {
      const croppedLogo = await getCroppedImg(
        selectedPartnerLogo,
        croppedAreaPixels
      );
      if (!croppedLogo) {
        console.error("Cropped image is null or undefined");
        return;
      }
      const croppedUrl = URL.createObjectURL(croppedLogo);
      setPartnerLogoUrl(croppedUrl);

      const result = await uploadPartnerImageInProfile(
        croppedLogo,
        "cropped.jpg"
      );
      const srcInResult = result.name;
      setPartnerLogo(result.name);
      setEditedPartnerLogo(result.name);
      setResultPartner((prevData) => ({
        ...prevData,
        partnerlogo: srcInResult,
      }));

      const imageUpload = await updatePartnerLogoOnChange({
        doctorid,
        partnerlogo: srcInResult,
      });

      if (imageUpload.output.success === 1) {
        editPartnerLogo.current.closeModal();
      }

      setShowPartnerLogoCropper(false);
    } catch (error) {
      console.error("Error handling cropped image:", error);
    }
    dismissLoader();
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    getDoctorProfile();
  }, []);

  const gobackfunction = ()=>{
    window.history.back();
   }

  return (
    <>
      {screenType === "web" ? (
        <Box w="100%">
          <Flex>
            <Box w={screenType === "web" ? "6rem" : "100%"}>
              {screenType === "web" ? <MiniSideBar /> : <MobileNavbar />}
            </Box>
            {isLoading && <Loader />}
            <Box w="100%">
              <SecondaryNav withBack="Partners" goBack={gobackfunction} />
              <Box
                gap="10px"
                my="1rem"
                px="1rem"
                w="100%"
                display="flex"
                flexDirection="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <Box
                  gap="10px"
                  // pl="1rem"
                  w="100%"
                  display="flex"
                  flexDirection="row"
                  justifyContent="start"
                  alignItems="center"
                >
                  <PrimaryInput
                    variant="fullRound"
                    title="Search by Partner or Branch name"
                    inputPlace="Search by Partner or Branch name"
                    id={"searchName"}
                    inputStyleCss={{ w: "350px" }}
                    onKeyDown={handleKeyDown}
                    onChange={(e) => handleChangeName(e)}
                    inputValue={searchValue}
                  />
                  <PrimaryButton
                    buttonText="Filter"
                    id="filterButton"
                    onClick={() => handleFilter()}
                    btnStyle={{ m: "0", w: "125px" }}
                  />
                  <PrimaryButton
                    buttonText="Reset"
                    id="resetButton"
                    variant="grayBtnFull"
                    btnStyle={{ color: "#AA2F27", m: "0", w: "125px" }}
                    onClick={() => resetFeilds()}
                  />
                </Box>
                {/* <PrimaryButton
                  buttonText="Master Branches"
                  onClick={() => navigate("/masterbranches", "_blank")}
                  variant="mdBtnFull"
                  btnIcon="/assets/svgs/new-tab.svg"
                  iconSrc={true}
                  iconSrcStyle={{ w: "14px" }}
                  btnStyle={{ w: "200px" }}
                  //  isDisabled={actionAccess && !actionAccess.create ? true : false}
                /> */}
                <PrimaryButton
                  buttonText="Add"
                  onClick={() => openPartnerModal("", "add")}
                  btnStyle={{ m: "0" }}
                  w="125px"
                  //   isDisabled={ actionAccess && (!actionAccess.create) ? true : false}
                />

                {/* {noData && <p>No data available</p>} */}
              </Box>
              <Divider />
              {resultPartner && resultPartner.length > 0 ? (
                <>
                  <Box
                    width="100%"
                    p="1rem"
                    overflow="hidden auto"
                    h="calc(100vh - 155px)"
                  >
                    <SimpleGrid
                      columns={{ base: 1, md: 2, lg: 3, xl: 4 }}
                      spacing="1rem"
                    >
                      {resultPartner &&
                        resultPartner.map((item, index) => (
                          <Card key={index} borderRadius="10px">
                            <CardBody
                              border="1px solid #E6E7E9"
                              borderRadius="10px"
                            >
                              <Flex
                                w="100%"
                                mb="0.75rem"
                                justifyContent="space-between"
                                alignItems="start"
                              >
                                <Box display="flex" flexDir="column">
                                  <Text fontSize="10px" color="gray.500">
                                    Partner name
                                  </Text>
                                  <Text
                                    fontSize="0.875rem"
                                    title={item.partnername}
                                    isTruncated
                                    fontWeight="600"
                                  >
                                    {item.partnername}
                                  </Text>
                                </Box>
                                <Box display="flex" gap="10px">
                                  <Box
                                    as="button"
                                    onClick={() =>
                                      openPartnerModal(item.id, "edit")
                                    }
                                    border="1px solid #E6E7E9"
                                    borderRadius="full"
                                    w="36px"
                                    h="auto"
                                    p="10px"
                                  >
                                    <Image
                                      w="13px"
                                      src="/assets/imgs/edit-gray.png"
                                    />
                                  </Box>

                                  <Box
                                    as="button"
                                    onClick={() => openDeletePartnerModal(item)}
                                    border="1px solid #E6E7E9"
                                    borderRadius="full"
                                    w="36px"
                                    h="auto"
                                    p="10px"
                                  >
                                    <Image
                                      w="13px"
                                      src="/assets/imgs/delete.png"
                                    />
                                  </Box>
                                </Box>
                              </Flex>
                              <Box display="flex" flexDir="column">
                                <Text fontSize="10px" color="gray.500">
                                  Branch name
                                </Text>
                                <Text fontSize="0.875rem" fontWeight="600">
                                  {item.branchname}
                                </Text>
                              </Box>
                            </CardBody>
                          </Card>
                        ))}
                    </SimpleGrid>
                  </Box>
                </>
              ) : (
                <Box width="100%">
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    py="2rem"
                  >
                    <Text fontSize="md" fontWeight="bold">
                      No Partners Found
                    </Text>
                  </Box>
                </Box>
              )}
            </Box>
          </Flex>
        </Box>
      ) : (
        <>
          <MobileNavbar />
          <MobileSecondaryNav
            header="Partners"
            handlebackarrow={() => navigate(`/profile`)}
          />
          <Box
            w="100%"
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            p="1rem"
            gap="0.75rem"
          >
            <SearchBar
              passInputPlace="Search by Partner"
              onKeyDown={handleKeyDown}
              onChange={(e) => handleChangeName(e)}
              handleClick={() => handleFilter()}
              searchValue={searchValue}
              placeholderMaxWidth="170px"
            />
            {searchValue && searchValue.length > 0 && (
              <PrimaryButton
                buttonText="X"
                id="resetButton"
                variant="grayBtn"
                btnStyle={{ color: "#AA2F27", m: "0", w: "50px" }}
                onClick={() => resetFeilds()}
              />
            )}
            <PrimaryButton
              buttonText="Add"
              onClick={() => openPartnerModal("", "add")}
              variant="mdBtn"
              btnStyle={{ w: "100%", maxW:'75px' }}
              //  isDisabled={actionAccess && !actionAccess.create ? true : false}
            />
          </Box>
          <Divider />
          {resultPartner && resultPartner.length > 0 ? (
            <>
              <Box
                width="100%"
                p="1rem"
                overflow="hidden auto"
                h="calc(100vh - 215px)"
              >
                <SimpleGrid columns={1} spacing="1rem">
                  {resultPartner &&
                    resultPartner.map((item, index) => (
                      <Card key={index} borderRadius="10px">
                        <CardBody
                          border="1px solid #E6E7E9"
                          borderRadius="10px"
                        >
                          <Flex
                            w="100%"
                            mb="0.75rem"
                            justifyContent="space-between"
                            alignItems="start"
                          >
                            <Box display="flex" flexDir="column">
                              <Text fontSize="10px" color="gray.500">
                                Partner name
                              </Text>
                              <Text
                                fontSize="0.875rem"
                                title={item.partnername}
                                isTruncated
                                fontWeight="600"
                              >
                                {item.partnername}
                              </Text>
                            </Box>
                            <Box display="flex" gap="10px">
                              <Box
                                as="button"
                                onClick={() =>
                                  openPartnerModal(item.id, "edit")
                                }
                                border="1px solid #E6E7E9"
                                borderRadius="full"
                                w="36px"
                                h="auto"
                                p="10px"
                              >
                                <Image
                                  w="13px"
                                  src="/assets/imgs/edit-gray.png"
                                />
                              </Box>

                              <Box
                                as="button"
                                onClick={() => openDeletePartnerModal(item)}
                                border="1px solid #E6E7E9"
                                borderRadius="full"
                                w="36px"
                                h="auto"
                                p="10px"
                              >
                                <Image w="13px" src="/assets/imgs/delete.png" />
                              </Box>
                            </Box>
                          </Flex>
                          <Box display="flex" flexDir="column">
                            <Text fontSize="10px" color="gray.500">
                              Branch name
                            </Text>
                            <Text fontSize="0.875rem" fontWeight="600">
                              {item.branchname}
                            </Text>
                          </Box>
                        </CardBody>
                      </Card>
                    ))}
                </SimpleGrid>
              </Box>
            </>
          ) : (
            <Box width="100%">
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                py="2rem"
              >
                <Text fontSize="md" fontWeight="bold">
                  No Partners Found
                </Text>
              </Box>
            </Box>
          )}
        </>
      )}

      <ModalRight
        ref={addPartner}
        header="Add New Partner"
        modalWidth={{ base: "100%", lg: "calc(100vw - 70%)" }}
        body={
          <>
            <Box py="1rem">
              <DropdownInput
                variant="topSide"
                dropDownPlace={
                  <span>
                    Select Branch List <span style={{ color: "red" }}>*</span>
                  </span>
                }
                options={clinicList}
                readOnly={true}
                id="clinic"
                // onClick={handleClinicChange}
                onClick={handleClinicSelect}
                defaultOption={clinics}
                menuList={{ pos: "absolute", right: "-45px", minW: "215px" }}
              />
              <PrimaryInput
                variant="downSide"
                inputPlace="Partner Name"
                // inputPlace={<span>Partner Name <span style={{color: 'red'}}>*</span></span>}
                inputValue={partnerName}
                onChange={(e) => setPartnerName(e.target.value)}
                maxLength={50}
              />

              <Box
                display="flex"
                gap="10px"
                h="100%"
                mt="1rem"
                alignItems="center"
              >
                {partnerLogo && (
                  <Box height="100%" w="35%">
                    <Image
                      src={
                        partnerLogo != null
                          ? resultPartner[0]?.imagepath + partnerLogo
                          : "/assets/imgs/no-image.png"
                      }
                      boxSize="90px"
                      borderRadius="10px"
                      objectFit="cover"
                    />
                  </Box>
                )}

                <Flex flexDir="column" gap="15px" w="100%">
                  <Input
                    type="file"
                    accept=".png,.jpg,.jpeg"
                    hidden
                    id="uploadPartnerLogo"
                    // onChange={handleLogoSelection}
                    ref={inputPartnerLogoRef}
                    onChange={handlePartnerLogoSelection}
                    // onChange={(e) => handleUploadDocument(e)}
                  />
                  <Box
                    as="button"
                    flexDir="column"
                    justifyContent="center"
                    alignItems="center"
                    w="100%"
                    p="20px"
                    gap="8px"
                    border="1px dashed #CDCFD4"
                    borderRadius="12px"
                    // onClick={handleUploadDegree}
                    // onClick={changeLogo}
                    onClick={changePartnerLogo}
                  >
                    <Image
                      w="20px"
                      m="auto"
                      mb="10px"
                      h="auto"
                      src="/assets/svgs/file-upload.svg"
                    />
                    <Text fontSize="14px" color="#163E9E" fontWeight="600">
                      Upload logo here
                    </Text>
                  </Box>
                </Flex>
              </Box>
            </Box>
          </>
        }
        footerActions={
          <>
            <Flex gap="1.5rem" w="100%">
              <PrimaryButton
                buttonText="Cancel"
                variant="grayBtnFull"
                btnStyle={{ color: "#AA2F27" }}
                onClick={() => addPartner.current.closeRight()}
              />
              <PrimaryButton buttonText="Save" onClick={saveClinicData} />
            </Flex>
          </>
        }
      />

      <ModalRight
        ref={editPartner}
        header="Edit Partner"
        modalWidth={{ base: "100%", lg: "calc(100vw - 70%)" }}
        body={
          <>
            <Box py="1rem">
              <DropdownInput
                variant="topSide"
                dropDownPlace={
                  <span>
                    Select Branch List <span style={{ color: "red" }}>*</span>
                  </span>
                }
                options={clinicList}
                readOnly={true}
                id="clinic"
                onClick={handleClinicSelect}
                defaultOption={editedClinics}
                menuList={{ pos: "absolute", right: "-45px", minW: "215px" }}
              />
              <PrimaryInput
                variant="downSide"
                inputPlace="Partner Name"
                defaultValue={editedPartnerName}
                inputValue={editedPartnerName}
                onChange={(e) => setEditedPartnerName(e.target.value)}
                maxLength={50}
              />

              <Box
                display="flex"
                gap="10px"
                h="100%"
                mt="1rem"
                alignItems="center"
              >
                {editedPartnerLogo && (
                  <Box height="100%" w="35%">
                    <Image
                      src={
                        editedPartnerLogo != null
                          ? resultPartner[0]?.imagepath + editedPartnerLogo
                          : "/assets/imgs/no-image.png"
                      }
                      boxSize="90px"
                      borderRadius="10px"
                      objectFit="cover"
                    />
                  </Box>
                )}

                <Flex flexDir="column" gap="15px" w="100%">
                  <Input
                    type="file"
                    accept=".png,.jpg,.jpeg"
                    hidden
                    id="uploadPartnerLogo"
                    // onChange={handleLogoSelection}
                    ref={inputPartnerLogoRef}
                    onChange={handlePartnerLogoSelection}
                    // onChange={(e) => handleUploadDocument(e)}
                  />
                  <Box
                    as="button"
                    flexDir="column"
                    justifyContent="center"
                    alignItems="center"
                    w="100%"
                    p="20px"
                    gap="8px"
                    border="1px dashed #CDCFD4"
                    borderRadius="12px"
                    onClick={changePartnerLogo}
                  >
                    <Image
                      w="20px"
                      m="auto"
                      mb="10px"
                      h="auto"
                      src="/assets/svgs/file-upload.svg"
                    />
                    <Text fontSize="14px" color="#163E9E" fontWeight="600">
                      Edit logo here
                    </Text>
                  </Box>
                </Flex>
              </Box>
            </Box>
          </>
        }
        footerActions={
          <>
            <Flex gap="1.5rem" w="100%">
              <PrimaryButton
                buttonText="Cancel"
                variant="grayBtnFull"
                btnStyle={{ color: "#AA2F27" }}
                onClick={() => addPartner.current.closeRight()}
              />
              <PrimaryButton buttonText="Save" onClick={saveClinicEditedData} />
            </Flex>
          </>
        }
      />

      <DynamicModal
        ref={editPartnerLogo}
        modalHeader="Upload Partner Logo"
        modalBody={
          <>
            {showPartnerLogoCropper && selectedPartnerLogo && (
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                h="400px"
                w="400px"
              >
                <ImageCropper
                  src={selectedPartnerLogo}
                  onCropComplete={handlePartnerLogoCropComplete}
                />
              </Box>
            )}
          </>
        }
        modalFooterBtn={
          <>
            <PrimaryButton
              buttonText="Upload"
              mr={3}
              onClick={() => {
                handlePartnerLogoCrop();
                editPartnerLogo.current.closeModal();
              }}
            />
            <PrimaryButton
              buttonText="Cancel"
              onClick={() => editPartnerLogo.current.closeModal()}
            />
          </>
        }
        size="lg"
      />

      <DynamicModal
        ref={deletePartner}
        modalHeader="Delete Partner"
        modalBody={
          <>
            <Text fontSize="14px" fontWeight="600">
              Are you sure you want to delete Partner "{partnerName}" ?
            </Text>
          </>
        }
        modalFooterBtn={
          <>
            <PrimaryButton
              variant="deleteBtn"
              buttonText="Delete"
              onClick={deletePartnerFromList}
            />
          </>
        }
      />
    </>
  );
};

export default PartnersIndex;
